import { Route, BrowserRouter, Routes } from 'react-router-dom';
import { CheckoutContent } from './CheckoutContent';
import { ApmDynamicPage } from './components/ApmDynamicPage/ApmDynamicPage';
import { PaymentStatusPage } from './pages/PaymentStatusPage';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorScreenFallbackRender } from './components/ErrorScreen/ErrorScreen';
import { StripePaymentHandlerPage } from './pages/StripePaymentHandlerPage';

export const Checkout = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary FallbackComponent={ErrorScreenFallbackRender}>
        <Routes>
          <Route path="/apm-dynamic-page" element={<ApmDynamicPage />} />
          <Route path="/:token" element={<CheckoutContent />} />
          <Route path="/status/:sessionId/:orderId" element={<PaymentStatusPage />} />
          <Route path="/" element={<CheckoutContent />} />
          <Route path="/handle-payment/:clientSecret/:publishableKey" element={<StripePaymentHandlerPage />} />
        </Routes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};
